export const environment = {
  production: true,
  firebase : {
    apiKey: "AIzaSyAPAutWLcKHFXScxs3YU0igSAUKdI_77uQ",
    authDomain: "finance-monitor-5d0ee.firebaseapp.com",
    databaseURL: "https://finance-monitor-5d0ee.firebaseio.com",
    projectId: "finance-monitor-5d0ee",
    storageBucket: "",
    messagingSenderId: "472682610115",
    appId: "1:472682610115:web:af7d33f462fb9ee5241176",
    production: false
  },
  frontDomain: 'https://fadoctor.bethelean.co.kr/:',
  serverDomain: 'https://fadoctor.bethelean.co.kr:8080',
  PUBLIC_SERVER: 'ops'
};
